import { GuiaremisionDetalle } from "./guiaremision_detalle";
import { Caja } from "./caja";
import { Venta } from './venta';
import { Compra } from './compra';
import { Cliente } from "./cliente";

export class Guiaremision {
    constructor(
        public id: number = 0,
        public tipo_comprobante_id: number = 0,
        public is_secuencial_manual: boolean = false,
        public numero_documento: String = "",
        public serie: String = "",
        public punto_emision: String = "",
        public secuencial: String = "",
        public numero_autorizacion: String = "",
        public fecha_emision: any = "",
        public tipo_identificacion_id: number = 0,
        public transportista_id: String = "",
        public dni_transportista: String = "",
        public razonSocial_transportista: String = "",
        public placa_transporte: String = "",
        public fecha_inicial_transporte: any = "",
        public fecha_final_transporte: any = "",
        public motivo_traslado:String = "venta",
        public modalidad: String = "CD", // CD => Con documento - SD => Sin documento
        public observacion:String ="",
        public destino: String = "",
        public cod_est: String = "PPR",
        public id_error: number = 0,
        public descripcion_error: String = "",
        public is_enviado: boolean = false,
        public json_string: any = {},
        public empresa_id: String = "",
        public sucursal_id: String = "",
        public caja_id: String = "",
        public documento_id: String = "",
        public cliente_id: String = "",
        public usuario_id:String = null,
        public status: String = "",

        public detalle: Array<GuiaremisionDetalle> = [],
        public caja: Caja = new Caja(),
        public venta: any = {},
        public compra: any = {},

        public tipocomprobante: any = {},
        public estadobitacora: any = {},
        public documento: any = {},
        public cliente: Cliente = new Cliente(),

    ){}
}



// WEBPACK FOOTER //
// /var/www/nodejs/nextstore/src/app/models/guiaremision.ts